<template>
  <div class="user_content">
    <div v-for="(item) in userList" :key="item.value" class="user_item">
        <div class="item_carrier" >
          <img v-if="item.corpCustomer" :src="qiyeIcon" class="customer_icon">
          <img v-else :src="kehuIcon" class="customer_icon">
          <span class="carrier_name" @click="handleSelect(item,item.label)">{{item.label}}({{ item.creditCode||item.value||item.code }})
            <span v-if="currentSelect===item.value" class="current_select">当前</span>
          </span>
        </div>
    </div>
    <a-modal
      v-model="visible"
      :closable="false"
      :mask-closable="false"
    >
      [{{chooseItem.label}}]的服务商[{{repeatName}}]存在多个相同企业统一信用编码的客户，请联系对应项目负责人处理后重试
      <template #footer>
        <a-button key="submit" type="primary" :disabled="!!time" @click="handleOk">已知晓<span v-if="time">({{ time }}s)</span></a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import qiyeIcon from '@/assets/img/auth/icon_qi_circle.png'
import kehuIcon from '@/assets/img/auth/icon_ke_circle.png'
import { EventBus } from '@/utils/event-bus'

  export default {
    name:'UserSelect',
    props:{
      userData:{
        type:Array,
        default:()=>([])
      }
    },
    data(){
      return {
        userList:[],
        qiyeIcon,
        kehuIcon,
        currentSelect:'',
        visible: false,
        chooseItem: {},
        timer: null,
        time: 0,
        repeatName: '',
      }
    },
    created(){
      EventBus.$on('searchUser',this.handleSearch)
      const {customerCode,creditCode}=this.$store.state.user
      if(creditCode){
        this.currentSelect=creditCode
      }else{
        this.currentSelect=customerCode
      }
      this.formatData([...this.userData])
    },
    beforeDestroy(){
       EventBus.$off('searchUser')
    },
    methods:{
      formatData(data,onlyShow){
       this.userList=data.map(item=>{
          if(item.corpCustomer){
            return{
              ...item,
              value:item.creditCode,
              label:item.corpName,
              isExpansion:false,
              isSelect:false,
              onlyShow,
              children:item.children.map(child=>{
                return {
                  ...child,
                  value:child?.ext?.customerCode,
                  label:child.name,
                  isSelect:false,
                }
              })
            }
          }
            return {
              ...item,
              value:item.ext?.customerCode,
              label:item.name,
              isSelect:false,
            }
          
        })
      },
      handleOk() {
        const item = this.chooseItem
        this.currentSelect=item.value
        const {creditCode,customerCode}=this.$store.state.user
        if(creditCode&&item.value!==creditCode||!creditCode&&item.value!==customerCode){
          this.$emit('change',item,item.label)
        }
        this.chooseItem = {}
        this.visible = false
      },
      handleSelect(item,label) {
        const codeList = [];
        const errCode = [];
        this.repeatName = '';
        (item.children || []).forEach(i => {
          const {creditCode} = i.ext || {};
          if (creditCode) {
            if (!codeList.includes(creditCode)) {
              codeList.push(creditCode)
              errCode.push(i)
            }
          }
        });
        if (codeList.length > 1) {
          this.repeatName = errCode[1].ownerTenantName
          this.time = 3
          this.chooseItem = item
          this.visible = true
          this.timer = setInterval(() => {
            if (this.time > 0) {
              this.time-=1;
            } else {
              clearInterval(this.timer)
            }
          }, 1000);
          this.$emit('changeVisible')
        } else {
          this.currentSelect=item.value
          const {creditCode,customerCode}=this.$store.state.user
          if(creditCode&&item.value!==creditCode||!creditCode&&item.value!==customerCode){
            this.$emit('change',item,label)
          }
        }
      },
      handleSearch(List){
        const {data,onlyShow}=List
        this.formatData(data,onlyShow)
      }
    }
  }
</script>

<style lang="less" scoped>
.user_content {
  // margin-right: 40px;
}
.company_item {
  margin-left: 16px;
  top: -6px;
}
.current_select {
  display: inline-block;
  margin-left: 5px;
  padding:0 6px;
  color: #fff;
  background-color: #06B880;
  border-radius: 2px;
  // position: absolute;
  // right: -40px;
  // width: 36px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  width: 40px;
  text-align: center;
}
.user_item{
   margin: 10px 0;
}

 .item_carrier {
   position: relative;
    padding-left: 6px;
    display: flex;
    align-items: center;
    .customer_icon {
      height: 20px;
      width: 20px;
      margin-right: 4px;
      z-index: 200;
    }
   .carrier_name {
      cursor: pointer;
      color: #323233;
      font-size: 14px;
      display: flex;
      align-items: center;
      &:hover{
        background-color: #E6F7F2;
      }
   }
 }
 .company_item {
   border-left: 1px solid #ebedf0;
   padding-left: 26px;
   position: relative;
    &::before{
      content: '';
      width: 20px;
      height: 1px;
      background: #ebedf0;
      display: block;
      position: absolute;
      top: 27px;
      left: -1px;
    }
    .customer_icon {
      position: relative;
      height: 20px;
      width: 20px;
      margin-right: 4px;
      top: 12px;
    }
   .carrier_name {
      cursor: pointer;
      position: relative;
      top: 13px;
      line-height: 28px;
      color: #646566;
      font-size: 14px;
       &:hover{
        background-color: #E6F7F2;
      }
   }
   .current_select {
  display: inline-block;
  padding:0 6px;
  color: #fff;
  background-color: #06B880;
  border-radius: 2px;
  position: absolute;
  right: -40px;
  top: 0px;
  // width: 36px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
 }
</style>